export const filtersConfig = {
  type: 'modal',
  settings: {
    name: {
      label: 'Dashboard::Search by name',
      type: 'text',
    },
    subjectType: {
      label: 'Dashboard::Select category of subject',
      type: 'select',
      options: [
        {
          label: 'Dashboard::Stakeholder',
          value: 'stakeholder',
        },
        {
          label: 'Dashboard::Location',
          value: 'location',
        },
        {
          label: 'Dashboard::Event',
          value: 'event',
        },
      ],
      ihneritValues: {
        stakeholder: [
          {
            label: 'Dashboard::Business Entity',
            value: 'businessEntity',
          },
          {
            label: 'Dashboard::Civil society',
            value: 'civil_society',
          }
        ],
        location: [
          {
            label: 'Dashboard::Village',
            value: 'village',
          },
          {
            label: 'Dashboard::Mine Site',
            value: 'mineSite',
          }
        ],
        event: [
          {
            label: 'Dashboard::Incident',
            value: 'incident',
          },
          {
            label: 'Dashboard::Risk Mitigation Action',
            value: 'riskMitigationAction',
          }
        ],
      }
    },
    subjectCategory: {
      label: 'Dashboard::Select type of subject',
      type: 'select',
      options: [],
      ihneritFrom: 'subjectType',
      showIfHasValue: 'subjectType',
    },
    progress: {
      label: 'Dashboard::Select progress',
      type: 'checkbox',
      options: [
        {
          label: 'Dashboard::Not started',
          value: 'notStarted',
        },
        {
          label: 'Dashboard::In progress',
          value: 'inProgress',
        },
        {
          label: 'Dashboard::Completed',
          value: 'completed',
        },
      ],
    },
  },
  ihneritedValues: ['subjectCategory'],
};
